import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Package, Phone, Mail } from "lucide-react";
const OrderSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("order");
  useEffect(() => {
    if (!orderNumber) {
      navigate("/magazin");
    }
  }, [orderNumber, navigate]);
  return <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-20 bg-muted/30">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-2xl mx-auto">
            <Card className="animate-scale-in">
              <CardContent className="p-12 text-center">
                <div className="mb-6 flex justify-center">
                  <div className="relative">
                    <div className="absolute inset-0 bg-green-500/20 rounded-full animate-ping"></div>
                    <CheckCircle className="h-24 w-24 text-green-500 relative" />
                  </div>
                </div>

                <h1 className="text-4xl font-bold text-primary mb-4">
                  Comandă plasată cu succes!
                </h1>
                
                <p className="text-xl text-muted-foreground mb-2">
                  Număr comandă: <span className="font-bold text-foreground">{orderNumber}</span>
                </p>

                <p className="text-muted-foreground mb-8">
                  Vei primi un email de confirmare în curând
                </p>

                <div className="bg-muted/50 rounded-lg p-6 mb-8 text-left space-y-4">
                  <div className="flex items-start gap-3">
                    <Package className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold mb-1">Ce urmează?</p>
                      <p className="text-sm text-muted-foreground">
                        Comanda ta va fi procesată în maxim 24 de ore. Vei fi contactat telefonic
                        pentru confirmarea comenzii și detalii despre livrare.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Phone className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold mb-1">Contact</p>
                      <p className="text-sm text-muted-foreground">
                        Pentru întrebări despre comandă, suntem disponibili la telefon sau email.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <Button size="lg" className="w-full" onClick={() => navigate("/magazin")}>
                    Continuă cumpărăturile
                  </Button>
                  
                  <Button variant="outline" size="lg" className="w-full" onClick={() => navigate("/")}>
                    Înapoi la pagina principală
                  </Button>
                </div>

                <div className="mt-8 pt-8 border-t">
                  <p className="text-sm text-muted-foreground mb-2">
                    Ai nevoie de ajutor?
                  </p>
                  <div className="flex items-center justify-center gap-4 text-sm">
                    <a href="tel:+40741234567" className="flex items-center gap-2 text-primary hover:underline">
                      <Phone className="h-4 w-4" />
                      +40 741 234 567
                    </a>
                    
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>

      <Footer />
    </div>;
};
export default OrderSuccess;